import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { itLocale, frLocale, deLocale, enGbLocale, esLocale } from 'ngx-bootstrap/locale';
import * as moment from 'moment';

const supportedLanguages = [
    "it",
    "fr",
    "de",
    "en",
    "es"
]

@Injectable({
    providedIn: 'root'
})
export class LanguagesService {

    selectedlanguage$: BehaviorSubject<string>

    private _languages: Array<string>;

    private _datepickerLang = {
        it: itLocale,
        fr: frLocale,
        de: deLocale,
        en: enGbLocale,
        es: esLocale
    }

    constructor(private translate: TranslateService, private localeService: BsLocaleService) {
        this.selectedlanguage$ = new BehaviorSubject('ita');
        this._languages = supportedLanguages;
        this._languages.forEach((language) => {
            defineLocale(language, this._datepickerLang[language]);
        });
    }

    get languages(): Array<string> {
        return [...this._languages];
    }

    initLanguage(language: string) {
        this.translate.setDefaultLang(language);
        this.selectLanguage(language);
    }

    selectLanguage(language: string) {
        if (this._languages.indexOf(language) == -1) {
            console.error(language, ' Not supported');
        } else {
            this.selectedlanguage$.next(language);
            this.localeService.use(language);
            this.translate.use(language);
            moment.locale(language);
        }
    }
}